var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"VueTables__sort ml-2"},[(_vm.props.sortable)?_c(_vm.icon,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }